import { withBounds } from '@clover-util/with-bounds';

/**
 * Adjusts the value by the delta and normalizes it to a value from 0 to 100
 *
 * @param value the base percentage
 * @param delta the amount to change from -1 to 1
 * @returns the adjusted number: value * (1 + delta)
 */
export function adjustPercentage(value: number, delta: number): number {
  const factor = withBounds(delta, { upper: 1, lower: -1 });

  const updated = value === 0 ? factor * 100 : value * (1 + factor);

  return withBounds(parseFloat(updated.toFixed(5)), { upper: 100, lower: 0 });
}
